import styled from 'styled-components/native';
import style, { hpx } from '../../../styles';

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  margin: 0 5px;
  padding: 14px 0;
  border-bottom-width: ${props => (props.noborder ? '0' : '1px')};
  border-bottom-color: #F0F0F0;
`;

export const Col = styled.View`
  margin-right: 12px;
`;

export const Text = styled.Text`
  font-size: ${style.fonts.xsmall};
  font-family: ${style.fontName.ubuntuRegular};
  color: #444;
`;

export const Icon = styled.Image`
  width: 18px;
  height: 18px;
  resize-mode: contain;
`;
